import { useState } from "react";
import { api } from "api";

const ENDPOINT = "prod_bodega_cierres_inventario";
const ENDPOINT_REAJUSTES = "prod_bodega_reajustes_inventario";

export const CreacionCierreApi = () => {
    const [cargando, setCargando] = useState(false);

    // cierre en proceso con sus filas ya calculadas; sin fecha el backend
    // calcula hasta el momento actual
    const getCierreAbierto = async (fecha, incluirSinMovimiento) => {
        try {
            setCargando(true);

            const params = {};

            if (fecha) {
                params.fecha = fecha;
            }

            if (incluirSinMovimiento) {
                params.incluir_sin_movimiento = true;
            }

            const response = await api.get(`${ENDPOINT}/abierto`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const cerrarCierre = async (id, data) => {
        try {
            setCargando(true);
            const response = await api.post(`${ENDPOINT}/${id}/cerrar`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const cancelarCierre = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // los dos siguientes no tocan `cargando` a propósito: se disparan al salir
    // de cada campo de la tabla y la máscara parpadearía en toda la pantalla
    const guardarObservacion = async (id, data) => {
        try {
            const response = await api.post(
                `${ENDPOINT}/${id}/guardar_observacion`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const guardarReajuste = async (data) => {
        try {
            const response = await api.post(ENDPOINT_REAJUSTES, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    return {
        getCierreAbierto,
        cerrarCierre,
        cancelarCierre,
        guardarObservacion,
        guardarReajuste,

        cargando,
    };
};
